// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slider[data-v-e7d257e0]{width:100%;overflow-y:hidden;opacity:0;transition-duration:.3s;-ms-overflow-style:none;scrollbar-width:none}.slider[data-v-e7d257e0]::-webkit-scrollbar{display:none}.slider_active[data-v-e7d257e0]{opacity:1}.slider_drag[data-v-e7d257e0]{cursor:grab}.slider__wrapper[data-v-e7d257e0]{will-change:transform;display:flex}.slide[data-v-e7d257e0]{flex-shrink:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
